import { makeActionFactory } from './actionFactory';
import { DeviceId, CameraCommand } from 'types';

export type ActionType =
    'PTZ_MOVE'
    | 'PTZ_LOCK'
    | 'PTZ_SET_LOCATION'
    | 'CAMERA_FN'
;

const actionFactory = makeActionFactory<ActionType>();


//
//  PTZ_MOVE action instructs the app to request the camera to move
//
export interface PtzMoveAction {
    type: 'PTZ_MOVE';
    payload: {
        deviceId: DeviceId;
        x: number;
        y: number;
        z: number;
        speed: number;
    };
}
export const ptzMove = actionFactory.payload<PtzMoveAction, { deviceId: DeviceId; x: number; y: number; z: number; speed: number }>('PTZ_MOVE');


//
//  PTZ_LOCK action instructs the app to request the server to lock or unlock PTZ controls for a camera
//
export interface PtzLockAction {
    type: 'PTZ_LOCK';
    payload: {
        deviceId: DeviceId;
        lock: boolean;
    };
}
export const ptzLock = actionFactory.payload<PtzLockAction, { deviceId: DeviceId; lock: boolean }>('PTZ_LOCK');


//
//  PTZ_SET_LOCATION  action instructs the app to request the camera to move to a preset location
//
export interface PtzSetLocationAction {
    type: 'PTZ_SET_LOCATION';
    payload: {
        deviceId: DeviceId;
        locationId: number;
    };
}
export const ptzSetLocation = actionFactory.payload<PtzSetLocationAction, { deviceId: DeviceId; locationId: number }>('PTZ_SET_LOCATION');


//
//  CAMERA_FN action instructs the app to request the camera to perform a special function
//
export interface CameraFnAction {
    type: 'CAMERA_FN';
    payload: {
        deviceId: DeviceId;
        commandId: CameraCommand;
    };
}
export const cameraFn = actionFactory.payload<CameraFnAction, { deviceId: DeviceId; commandId: CameraCommand }>('CAMERA_FN');



// WEBPACK FOOTER //
// ./src/actions/cameraActions.ts